import React from 'react';

import { Icon, SimpleTooltip } from '@eluve/components';

export interface PreviewGenerationStatsProps {
  durationMs: number;
  inputTokens?: number;
  outputTokens?: number;
}

const formatDuration = (ms: number): string =>
  ms < 1000 ? `${Math.round(ms)} ms` : `${(ms / 1000).toFixed(1)} s`;

/** Footer under a generated preview: generation time and token usage. */
export const PreviewGenerationStats: React.FC<PreviewGenerationStatsProps> = ({
  durationMs,
  inputTokens,
  outputTokens,
}) => (
  <div className="mt-2 flex items-center gap-2 border-t border-border-primary/60 pt-3 text-xs text-text-tertiary">
    <Icon name="Clock" size="xs" />
    <span>Generated in {formatDuration(durationMs)}</span>
    {inputTokens !== undefined && outputTokens !== undefined && (
      <>
        <span aria-hidden>·</span>
        <SimpleTooltip
          label={`${inputTokens.toLocaleString()} input · ${outputTokens.toLocaleString()} output`}
        >
          <span>{(inputTokens + outputTokens).toLocaleString()} tokens</span>
        </SimpleTooltip>
      </>
    )}
  </div>
);
